import { render, staticRenderFns } from "./AISubtitles.vue?vue&type=template&id=29b34816&scoped=true"
import script from "./AISubtitles.vue?vue&type=script&setup=true&lang=ts"
export * from "./AISubtitles.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AISubtitles.vue?vue&type=style&index=0&id=29b34816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b34816",
  null
  
)

export default component.exports